export const SITE = {
  name: "SimFinance",
  tagline: "Africa’s intelligent digital financial ecosystem.",
  location: "Ghana",
  email: "",
  phone: "",
  social: [
    { name: "LinkedIn", href: "" },
    { name: "X", href: "" },
    { name: "Facebook", href: "" },
    { name: "Instagram", href: "" },
  ],
};

export function hashHref(id) {
  const hash = id.startsWith("#") ? id : `#${id}`;
  return `/${hash}`;
}
